import axios from 'axios';

import { BASE_URL } from '../../constants/baseUrl';
import { STORAGE_KEYS } from '../../constants/storageKeys';

class LoginService {
  userLogin(user) {
    // Convert user object to URLSearchParams format (form data)
    const formData = new URLSearchParams();
    formData.append('grant_type', 'password');
    formData.append('username', user.username);
    formData.append('password', user.password);
    formData.append('scope', '');

    return axios
      .post(`${BASE_URL}/v1/user/token`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data) // Resolving the API response data
      .catch((error) => {
        let errorMessage = 'Login failed. Please try again.';
        if (error.response?.data?.detail) {
          if (typeof error.response.data.detail === 'string') {
            errorMessage = error.response.data.detail;
          } else if (Array.isArray(error.response.data.detail)) {
            errorMessage = error.response.data.detail
              .map((err) => err.msg)
              .join(', ');
          }
        }
        return Promise.reject(errorMessage);
      });
  }

  /**
   * Refreshes the access token using a refresh token
   * @param {string} refreshToken - The refresh token to use for obtaining a new access token
   * @returns {Promise<{access_token: string, refresh_token?: string}>} Promise resolving to token data
   * @throws {Error} If refresh fails or refresh token is invalid
   */
  refreshToken(refreshToken) {
    if (!refreshToken) {
      return Promise.reject(new Error('Refresh token is required'));
    }

    // Send as JSON object since API expects application/json
    const requestBody = {
      refresh_token: refreshToken,
    };

    return axios
      .post(`${BASE_URL}/v1/user/refresh`, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (!response.data?.access_token) {
          throw new Error('Invalid response: missing access_token');
        }
        return response.data;
      })
      .catch((error) => {
        // Clean up tokens on any error
        sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
        sessionStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);

        // Return a more descriptive error
        const errorMessage =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.message ||
          'Token refresh failed. Please login again.';

        return Promise.reject({
          ...error,
          message: errorMessage,
          isRefreshError: true,
        });
      });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LoginService();
